<p-dialog *ngIf="displayResourceBalanceDialog" (onHide)="hideDialog($event)" [(visible)]="displayResourceBalanceDialog"
          [style]="DialogStyle65" header="Project Resource Balance" [contentStyle]="{'overflow-y':'auto'}" [closable]="false">
  <form #dialogForm="ngForm">
    <div class="p-grid">
          <div class="p-col-12 p-md-6 p-lg-6">
            <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label> Task Name</label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              {{selectedProjectTask.name}}
            </div>
            </div>
          </div>

        <div class="p-col-12 p-md-6 p-lg-6">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label> Total Initial Employee Labor ITD</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            {{selectedProjectTaskBalance?.currentYearEmployeeLaborITD | currency: Format.Currency}}
          </div>
        </div>
        <div class="p-col-12 p-md-6 p-lg-6">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label> Available Employee Labor ITD</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            {{selectedProjectTaskBalance?.currentYearEmployeeLaborITD - calculateTotalITD(EmployeeType.Employee) | currency: Format.Currency}}
            <span *ngIf="(selectedProjectTaskBalance?.currentYearEmployeeLaborITD - calculateTotalITD(EmployeeType.Employee) < 0)"><button pButton class="icon-negative"
                                                                                                                                           icon="fa fa-exclamation-triangle" pTooltip="Available value less than zero">
              </button> </span>
          </div>
        </div>
        <div class="p-col-12 p-md-6 p-lg-6">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label> Total Initial Subcontractor Labor ITD</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            {{selectedProjectTaskBalance?.currentYearSubcontractorLaborITD | currency: Format.Currency}}
          </div>
        </div>

        <div class="p-col-12 p-md-6 p-lg-6">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label> Available Subcontractor Labor ITD</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            {{selectedProjectTaskBalance?.currentYearSubcontractorLaborITD - calculateTotalITD(EmployeeType.SubContractor) | currency: Format.Currency}}
            <span *ngIf="(selectedProjectTaskBalance?.currentYearSubcontractorLaborITD - calculateTotalITD(EmployeeType.SubContractor) < 0)"><button pButton class="icon-negative"
                                                                                                                                                     icon="fa fa-exclamation-triangle" pTooltip="Available value less than zero">
              </button> </span>
          </div>
        </div>

            <div class="p-col-12 p-md-6 p-lg-6">
              <div class="p-col-12 p-md-4 p-lg-4">
                <label> Total Initial Employee Labor YTD</label>
              </div>
              <div class="p-col-12 p-md-8 p-lg-8">
                {{selectedProjectTaskBalance?.currentYearEmployeeLaborYTD | currency: Format.Currency}}
              </div>
            </div>
            <div class="p-col-12 p-md-6 p-lg-6">
              <div class="p-col-12 p-md-4 p-lg-4">
                <label> Available Employee Labor YTD</label>
              </div>
              <div class="p-col-12 p-md-8 p-lg-8">
                {{selectedProjectTaskBalance?.currentYearEmployeeLaborYTD - calculateTotalYTD(EmployeeType.Employee) | currency: Format.Currency}}
                <span *ngIf="(selectedProjectTaskBalance?.currentYearEmployeeLaborYTD - calculateTotalYTD(EmployeeType.Employee) < 0)"><button pButton class="icon-negative"
                                                                                                                                               icon="fa fa-exclamation-triangle" pTooltip="Available value less than zero">
                  </button> </span>
              </div>
            </div>
            <div class="p-col-12 p-md-6 p-lg-6">
              <div class="p-col-12 p-md-4 p-lg-4">
                <label> Total Initial Subcontractor Labor YTD</label>
              </div>
              <div class="p-col-12 p-md-8 p-lg-8">
                {{selectedProjectTaskBalance?.currentYearSubcontractorLaborYTD | currency: Format.Currency}}
              </div>
            </div>

            <div class="p-col-12 p-md-6 p-lg-6">
              <div class="p-col-12 p-md-4 p-lg-4">
                <label> Available Subcontractor Labor YTD</label>
              </div>
              <div class="p-col-12 p-md-8 p-lg-8">
                {{selectedProjectTaskBalance?.currentYearSubcontractorLaborYTD - calculateTotalYTD(EmployeeType.SubContractor) | currency: Format.Currency}}
                <span *ngIf="(selectedProjectTaskBalance?.currentYearSubcontractorLaborYTD - calculateTotalYTD(EmployeeType.SubContractor) < 0)"><button pButton class="icon-negative"
                                                                                                                                                         icon="fa fa-exclamation-triangle" pTooltip="Available value less than zero">
                  </button> </span>
              </div>
            </div>
    </div>
  </form>
  <div class="p-col-12">


    <app-data-table [columns]="resourceBalanceColumns" [value]="selectedProjectResourceBalances"
                    [rows]="PrimeNgConfig.LargeTableRows" [rowsPerPageOptions]="PrimeNgConfig.LargeTableRowsPerPage"
                    [footerTemplate]="footerTemplate" [bodyTemplate]="bodyTemplate">


      <ng-template #bodyTemplate let-row="row" let-columns="columns">
        <tr>
          <td *ngFor="let col of columns" [ngSwitch]="col.field">
            <!-- <span class=pumn-title">{{col.header}}</span> -->
            <span class="p-cell">

              <div *ngSwitchCase="'actualHours'">
                <input type="number" [(ngModel)]="row.actualHours" name="actualHours" pInputText />

              </div>
              <div *ngSwitchCase="'employeeLaborYTD'">
                <span class="p-inputgroup">
                  <input type="number" [(ngModel)]="row.employeeLaborYTD" name="employeeLaborYTD" pInputText />
                  <span class=" p-inputgroup-addon">$</span>
                </span>
              </div>
              <div *ngSwitchCase="'employeeLaborITD'">
                <span class="p-inputgroup">
                  <input type="number" [(ngModel)]="row.employeeLaborITD" name="employeeLaborITD" pInputText />
                  <span class=" p-inputgroup-addon">$</span>
                </span>
              </div>
              <div *ngSwitchCase="'subcontractorLaborYTD'">
                <span class="p-inputgroup">
                  <input type="number" [(ngModel)]="row.subcontractorLaborYTD" name="subcontractorLaborYTD" pInputText />
                  <span class=" p-inputgroup-addon">$</span>
                </span>
              </div>
              <div *ngSwitchCase="'subcontractorLaborITD'">
                <span class="p-inputgroup">
                  <input type="number" [(ngModel)]="row.subcontractorLaborITD" name="subcontractorLaborITD" pInputText />
                  <span class=" p-inputgroup-addon">$</span>
                </span>
              </div>
              <div *ngSwitchDefault>{{row[col.field]}}</div>
            </span>
          </td>
        </tr>
      </ng-template>

      <ng-template  #footerTemplate>
        <tr class="account-row-highlight">
          <td colspan="1"> </td>
          <td><b>Total</b></td>
          <td [class]="ClassType.CurrencyInTable"> <strong> {{calculateTotalHours()}}</strong> </td>
          <td [class]="ClassType.CurrencyInTable"> <strong> {{calculateTotalYTD(EmployeeType.Employee) | currency: Format.Currency}}</strong> </td>
          <td [class]="ClassType.CurrencyInTable"> <strong> {{calculateTotalITD(EmployeeType.Employee) | currency: Format.Currency}}</strong> </td>
          <td [class]="ClassType.CurrencyInTable"> <strong> {{calculateTotalYTD(EmployeeType.SubContractor) | currency: Format.Currency}} </strong></td>
          <td [class]="ClassType.CurrencyInTable"> <strong> {{calculateTotalITD(EmployeeType.SubContractor) | currency: Format.Currency}} </strong></td>

        </tr>
      </ng-template>
    </app-data-table>

<!--    <p-table [columns]="resourceBalanceColumns" [value]="selectedProjectResourceBalances">-->

<!--      <ng-template pTemplate="header" let-columns>-->
<!--        <tr>-->
<!--          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngSwitch]="col.field">-->
<!--            {{col.header}}-->
<!--          </th>-->
<!--        </tr>-->
<!--      </ng-template>-->

<!--      <ng-template pTemplate="body" let-row let-rowIndex="rowIndex" let-columns="columns">-->
<!--        <tr>-->
<!--          <td *ngFor="let col of columns" [ngSwitch]="col.field">-->
<!--            &lt;!&ndash; <span class=pumn-title">{{col.header}}</span> &ndash;&gt;-->
<!--            <span class="p-cell">-->

<!--              <div *ngSwitchCase="'actualHours'">-->
<!--                <input type="number" [(ngModel)]="row.actualHours" name="actualHours" pInputText />-->

<!--              </div>-->
<!--              <div *ngSwitchCase="'employeeLaborYTD'">-->
<!--                <span class="p-inputgroup">-->
<!--                  <input type="number" [(ngModel)]="row.employeeLaborYTD" name="employeeLaborYTD" pInputText />-->
<!--                  <span class=" p-inputgroup-addon">$</span>-->
<!--                </span>-->
<!--              </div>-->
<!--              <div *ngSwitchCase="'employeeLaborITD'">-->
<!--                <span class="p-inputgroup">-->
<!--                  <input type="number" [(ngModel)]="row.employeeLaborITD" name="employeeLaborITD" pInputText />-->
<!--                  <span class=" p-inputgroup-addon">$</span>-->
<!--                </span>-->
<!--              </div>-->
<!--              <div *ngSwitchCase="'subcontractorLaborYTD'">-->
<!--                <span class="p-inputgroup">-->
<!--                  <input type="number" [(ngModel)]="row.subcontractorLaborYTD" name="subcontractorLaborYTD" pInputText />-->
<!--                  <span class=" p-inputgroup-addon">$</span>-->
<!--                </span>-->
<!--              </div>-->
<!--              <div *ngSwitchCase="'subcontractorLaborITD'">-->
<!--                <span class="p-inputgroup">-->
<!--                  <input type="number" [(ngModel)]="row.subcontractorLaborITD" name="subcontractorLaborITD" pInputText />-->
<!--                  <span class=" p-inputgroup-addon">$</span>-->
<!--                </span>-->
<!--              </div>-->
<!--              <div *ngSwitchDefault>{{row[col.field]}}</div>-->
<!--            </span>-->
<!--          </td>-->
<!--        </tr>-->
<!--      </ng-template>-->

<!--      <ng-template pTemplate="footer">-->
<!--        <tr class="account-row-highlight">-->
<!--          <td colspan="1"> </td>-->
<!--          <td><b>Total</b></td>-->
<!--          <td [class]="ClassType.CurrencyInTable"> <strong> {{calculateTotalHours()}}</strong> </td>-->
<!--          <td [class]="ClassType.CurrencyInTable"> <strong> {{calculateTotalYTD(EmployeeType.Employee) | currency: Format.Currency}}</strong> </td>-->
<!--          <td [class]="ClassType.CurrencyInTable"> <strong> {{calculateTotalITD(EmployeeType.Employee) | currency: Format.Currency}}</strong> </td>-->
<!--          <td [class]="ClassType.CurrencyInTable"> <strong> {{calculateTotalYTD(EmployeeType.SubContractor) | currency: Format.Currency}} </strong></td>-->
<!--          <td [class]="ClassType.CurrencyInTable"> <strong> {{calculateTotalITD(EmployeeType.SubContractor) | currency: Format.Currency}} </strong></td>-->

<!--        </tr>-->
<!--      </ng-template>-->

<!--    </p-table>-->

  </div>
  <p-footer>
    <div class="details">
      <button pButton type="button" class="button-inaction" icon="fa fa-close" (click)="cancelProjectResourceBalance()" label="Cancel">
      </button>
      <span *ngIf="!goLiveAccountingPeriodClosed || inSolutionManager">
        <button [disabled]="(((selectedProjectTaskBalance.currentYearEmployeeLaborITD - calculateTotalITD(EmployeeType.Employee) ) < 0) ||
        ((selectedProjectTaskBalance.currentYearSubcontractorLaborITD - calculateTotalITD(EmployeeType.SubContractor) ) < 0) ||
        ((selectedProjectTaskBalance.currentYearEmployeeLaborYTD - calculateTotalYTD(EmployeeType.Employee) ) < 0) ||
         ((selectedProjectTaskBalance.currentYearSubcontractorLaborYTD - calculateTotalYTD(EmployeeType.SubContractor) ) < 0))" pButton icon="fa fa-check"
          type="button" class="button-action" (click)="saveProjectResourceBalance()" label="Save"></button>
      </span>

      <button *ngIf="user.hasRole[Roles.ImplementationAdminRole]" pButton type="button" class="button-inaction" icon="fa fa-close"
              (click)="rollUpResourceBalances()" label="Roll up Balances">
      </button>


    </div>
  </p-footer>

</p-dialog>
